import CheckoutPage from './themes/BGH/CheckoutPage';

export default CheckoutPage;
